module.exports = __webpack_public_path__ + "img/artboard–4.75166725.png";